const state_config = {
    url: '/ad_offer_popups',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Ad Offer Popups',
        role: 'offers',
    },
};
export default state_config;
